"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPayloadChallenge = void 0;
/* eslint-disable import/prefer-default-export */
var conversions_1 = require("../../../../utils/conversions");
var DeviceCharacteristic_1 = require("../../../../common/DeviceCharacteristic");
var setPayloadChallenge = function (device, value) {
    // const buffer = new ArrayBuffer(2);
    // const view = new DataView(buffer);
    // const decimalValue = parseInt(value.payloadChallengeCode, 16);
    // console.log('DECIMAL VALUE', decimalValue);
    // view.setUint16(0, decimalValue);
    var _a;
    var payloadChallengeCode = (0, conversions_1.hexStringToArrayBuffer)(value.payloadChallengeCode);
    return device.writeCharacteristicValues((_a = device.profile) === null || _a === void 0 ? void 0 : _a.DEVICE_MANAGEMENT.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.DeviceManagementCharacteristics.CHALLENGE; }).uuid, payloadChallengeCode, false);
};
exports.setPayloadChallenge = setPayloadChallenge;
